import { useMutation } from "@tanstack/react-query";
import archiveAppointment from "../../controllers/appointments/archive-appointment";

const useArchiveAppointment = () => {
  return useMutation(archiveAppointment, {});
};

export default useArchiveAppointment;
